export default __webpack_public_path__ + "static/media/ConveyorMk4.256.fd31da5e.png";